import {DoppeViewerLangDictionaryEn} from './doppe-viewer-lang-dictionary.en';

export const DoppeViewerLangDictionaryHe: typeof DoppeViewerLangDictionaryEn = {
    contactFormNameFieldPlaceholder: `שם`,
    contactFormEmailFieldPlaceholder: `מייל`,
    contactFormPhoneFieldPlaceholder: `טלפון`,
    createdWithHopp: 'צור את הלינק בביו שלך',
    collectSubscribersEmailFieldPlaceholder: 'הכניסו כתובת מייל',
    collectSubscribersPhoneFieldPlaceholder: 'הכניסו מספר טלפון',
    contactFormMessageFieldPlaceholder: `הכניסו הודעה`,
    collectSubscribersEmailMenuItem: 'מייל',
    collectSubscribersPhoneFieldMenuItem: 'טלפון',
    autoRedirectBannerRedirectingText: (options: {
        normalizedHostName: string,
        countdown: number,
    }) => `עוברים הלאה ל ${options.normalizedHostName}  ${options.countdown > 0 ? ` בעוד ${options.countdown} שניות` : ''}  `,
    autoRedirectBannerRedirectingCancelText: 'ביטול',
    autoRedirectBannerRedirectingCloseText: 'סגור',
    termsOfServiceText: 'ע"י שימוש ב Hopp אתם מאשרים שקראתם והסכמתם ל',
    termsOfServiceTextAnd: 'וגם ל',
    termsOfServiceTextOf: 'של',
    termsOfServiceLabel: 'תנאי השימוש',
    termsOfServicePrivacyLabel: 'מדיניות הפרטיות',
    subscribeCheckBoxText: (options: {
        username: string,
    }) => `על ידי סימון התיבה ושליחת הטופס אתם מספקים מידע ל ${options.username}, אשר יכול לפנות אלייכם עבור מטרות שיווק.`,
    subscribeConsentText: (options: {
        username: string,
    }) => `על ידי שליחת הטופס אתם מספקים מידע ל ${options.username}, אשר יכול לפנות אלייך עבור מטרות שיווק.`,
    subscribeThankYou: 'תודה שנרשמתם!',
    formThankYou: 'תודה ששלחתם!',
    requiredField: 'שדה חובה',
    requiredConsent: 'אישור חובה',
    enterValidPhone: 'הכניסו מסםר טלפון תקין',
    enterValidEmail: 'הכניסו כתובת מייל תקינה',
    youMustAgree: 'אתם חייבים לאשר את הסכם ההרשמה כדי להמשיך',
    skip: 'דלגו לאתר',
    beforeYouMoveOn: 'לפני שאתם ממשיכים הלאה ל...',
    redirectingIn: (seconds: number) => `עובר בעוד ${seconds}`,
    connectedLink: 'לינק מחובר',
    claim: `צרו חשבון Hopp היום`,
    claimYourAccount: 'צרו חשבון',
    tryForFree: 'נסה את Hopp',
    goToLink: `עברו ללינק`,
    enterACode: `חפשו או הכניסו מילת מפתח`,
    noLinksMatching: `אין לינקים אשר מתאימים למילת המפתח שהכנסתם`,
    accessSharedLink: `עברו ללינק המשותף ע"י הכנסת מילת מפתח המצויינת באחד הפוסטים שלי`,
    copiedToClipboard: 'הועתק לקלפיבורד',
    recentLinks: `לינקים אחרונים`,
    links: `לינקים`,
    pageContent: `לינקים ותוכן מהדף`,
    recentCodes: `מילות מפתח אחרונות`,
    codes: `מילות מפתח`,
    includesCoupon: 'קיים קופון',
    continue: 'המשיכו לאתר',
    backToSearch: 'חזרו לחיפוש',
    seeMore: 'קראו עוד',
    back: 'אחורה',
    code: 'מילת מפתח',
    contactFormZipCodeFieldPlaceholder: 'מיקוד',
    contactFormAddressFieldPlaceholder: 'כתובת',
    enterValidAddress: 'הכניסו כתובת חוקית',
    enterValidZip: 'הכניסו מיקוד חוקי',
    contentLoadingErrorTitle: `נכשל בטעינת התוכן`,
    contentLoadingErrorDescription: `אנא טען את הדף מחדש כדי לנסות שוב`,
    contentUnavailableTitleDefault: `תוכן זה אינו זמין כרגע`,
    contentUnavailableTitleBlog: 'טעינת הפוסט נכשלה',
    contentUnavailableTitleService: 'טעינת השירות נכשלה',
    contentUnavailableTitleProduct: 'טעינת המוצר נכשלה',
    contentUnavailableTitlePlan: 'טעינת התוכנית נכשלה',
    coupon: 'קופון',
    continueToWebsite: 'המשיכו לאתר',
    couponDescription: 'העתיקו את הקופון והמשיכו לאתר',
    checkoutFormAdditionalInformationFieldLabel: 'מידע נוסף',
    checkoutFormAdditionalInformationFieldPlaceholder: 'הערות מיוחדות עבור המוכר',
    checkoutFormMessageFieldLabel: 'הודעה',
    checkoutFormMessageFieldPlaceholder: 'הודעה למוכר',
    fulfillmentDetails: 'פרטי משלוח',
    cardNumber: 'מספר כרטיס',
    cardExpirationyPlaceholder: 'MM/YY',
    cardExpiration: 'תוקף',
    cardCVC: '3 ספרות',
    cardCountry: 'מדינה',
    checkoutAddressLine: 'כתובת',
    securedPaymentByStripe: 'תשלום מאובטח ע"י Stripe',
    requestsInstructions: 'הוראות מיוחדות',
    checkoutAddressStreetAddress: 'עיר ורחוב',
    fullNamePlaceholder: 'שם פרטי ושם משפחה',
    fullName: 'שם מלא',
    email: 'אימייל',
    checkoutPhone: 'טלפון',
    paymentError: 'אנו נתקלים בבעיות בעיבוד התשלום שלך. אנא נסה שוב מאוחר יותר.',
    checkoutContactInformation: 'פרטי יצירת קשר',
    paymentDetails: 'פרטי תשלום',
    billingDetails: 'פרטי חיוב',
    cookieConsentAccept: 'אישור',
    cookieConsentDeclineAll: 'דחיה',
    cookieConsentSettings: 'הגדרות',
    cookieConsentDescription: 'אנחנו משתמשים בקוקיז באתר שלנו כדי להבין את אופן השימוש שלך באתר. אם תאשר/י את השימוש בקוקיז, זה ייחשב כהסכמה מצידך לשימוש שלנו בקוקיז כאלה.',
    cookieConsentModalTitle: 'הגדרות עוגיות מתקדמות',
    cookieConsentEssentialTitle: 'קוקיז חיוניים',
    cookieConsentEssentialContent: 'קוקיז אלה מאפשרים פעולות מרכזיות כמו אבטחה, אימות זהות וניהול רשת. לא ניתן להשבית את הקוקיז האלו.',
    cookieConsentMarketingTitle: 'הפעלת קוקיז לצורכי שיווק',
    cookieConsentMarketingContent: 'קוקיז אלה משמשים כדי לעקוב אחר יעילות הפרסום על מנת לספק שירות יותר רלוונטי ולהציג מודעות רלוונטיות יותר שיתאימו לתחומי העניין שלך.',
    cookieConsentFunctionalTitle: 'הפעלת קוקיז פונקציונאלים',
    cookieConsentFunctionalContent: 'קוקיז אלה אוספים מידע כדי לזכור בחירות שמשתמשים מבצעים על מנת להשתפר ולתת חוויה יותר אישית.',
    cookieConsentSettingsSaveButton: 'שמירה',
    cookieConsentAnalyticsTitle: 'הפעלת קוקיז לניתוח מידע',
    cookieConsentAnalyticsContent: 'קוקיז אלה עוזרים לנו להבין איך מבקרים משתמשים באתר שלנו, לגלות שגיאות ולספק ניתוח מידע טוב יותר באופן כללי.',
    viewMoreButton: 'הצג עוד',
    viewLessButton: 'הצג פחות',
    seoSettingsTitleAutoText: '{displayname} - Hopp Link in Bio page',
    seoSettingsDescriptionAutoText: 'This page was created by {displayname} with Hopp by Wix',
    showAll: 'הצג הכל',
    showLess: 'הצג פחות',
}